import { useQuery } from "@tanstack/react-query";
import { artefactsApi } from "../api/artefacts";

export const useFetchArtefactsState = (projectId: string | undefined) => {

    const { data, isFetching, isPending, isError, refetch } = useQuery({
        queryKey: ["artefact-document-state", projectId],
        queryFn: () => artefactsApi.fetchArtefactsDetailsCount(projectId),
    });

    return {
        artefactsDataState: data?.data,
        isPending, isFetching, isError,
        refetch: refetch
    }

};